import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../assets/images/logo.png';

const FooterContainer = styled.footer`
  background-color: var(--dark-color);
  padding: 60px 0 20px;
  border-top: 1px solid rgba(188, 179, 113, 0.2);
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 40px;
  
  @media (max-width: 991px) {
    flex-direction: column;
    gap: 30px;
    text-align: center;
  }
`;

const FooterLogo = styled.div`
  img {
    height: 60px;
  }
`;

const FooterLinks = styled.div`
  ul {
    display: flex;
    flex-wrap: wrap;
    
    @media (max-width: 991px) {
      justify-content: center;
    }
  }
  
  li {
    margin-right: 20px;
    margin-bottom: 10px;
    
    @media (max-width: 576px) {
      margin-right: 15px;
    }
  }
  
  a {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.9rem;
    letter-spacing: 1px;
  }
`;

const SocialMedia = styled.div`
  display: flex;
  gap: 15px;
`;

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: var(--grey-color);
  border-radius: 50%;
  color: var(--text-color);
  font-size: 1.2rem;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: var(--primary-color);
    color: var(--secondary-color);
    transform: translateY(-5px);
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(188, 179, 113, 0.2);
  color: var(--light-color);
  font-size: 0.9rem;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterLogo>
            <img src={logo} alt="Dev Team Six Logo" />
          </FooterLogo>
          <FooterLinks>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/projects">Projetos</Link></li>
              <li><Link to="/contact">Contato</Link></li>
            </ul>
          </FooterLinks>
          <SocialMedia>
            <SocialIcon href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i>
            </SocialIcon>
            <SocialIcon href="https://github.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-github"></i>
            </SocialIcon>
            <SocialIcon href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </SocialIcon>
          </SocialMedia>
        </FooterContent>
        <Copyright>
          <p>&copy; {new Date().getFullYear()} Dev Team Six Brasil. Todos os direitos reservados.</p>
        </Copyright>
      </div>
    </FooterContainer>
  );
};

export default Footer;
